import { get, isNil } from "lodash";

const DUMMY_ICON = "https://icon-library.com/images/icon-url/icon-url-15.jpg";

const buildCardBlockHtml = ({ costs, upsells, addLinks, buttonLabel }) => {
  if (!costs?.length) return "";

  return `<div>
    ${costs.reduce(
      (accumulator, { insurancePlan, cost }) =>
        (accumulator += `<div
        style="
        padding: 12px 24px;
        border: 1px solid #e7e7e7;
        border-radius: 16px;
        font-family: 'Nunito', sans-serif;background:#fff
        "
    >
        <table style="font-family: 'Nunito', sans-serif">
        <tr style="font-family: 'Nunito', sans-serif">
            <td style="width: 110px; max-height: 100px; font-family: 'Nunito', sans-serif">
                <img width="110" 
                    src="${
                      isNil(insurancePlan.icon)
                        ? DUMMY_ICON
                        : insurancePlan.icon
                    }"
                    alt="${get(
                      insurancePlan,
                      "name",
                    )}" width="110" style="font-family: 'Nunito', sans-serif; width: 110px; height: auto; max-width: 110px; max-height: 60px; display: block; border: 0; line-height: 0; text-decoration: none;" />
            </td>
            <td
            style="padding: 0 16px; width: 40%; font-family: 'Nunito', sans-serif"
            >
            <div style="margin: 0; font-family: 'Nunito', sans-serif">
                <p
                style="
                    font-size: clamp(12px, 3vw, 16px);
                    font-weight: 600;
                    margin:0 0 14px 0;
                    color: #272c49;
                    font-family: 'Nunito', sans-serif;
                "
                >
                ${get(insurancePlan, "name")}
                </p>
                <div style="font-family: 'Nunito', sans-serif">
                <span
                    style="
                    font-family: 'Inter', sans-serif;
                    font-size: 32px;
                    font-weight: 900;
                    display: inline;
                    color: #272c49;
                    "
                    >${cost}</span
                >
                <span
                    style="
                    font-family: 'Inter', sans-serif;
                    font-size: 32px;
                    font-weight: 900;
                    display: inline;
                    color: #272c49;
                    "
                >
                    <span
                    style="
                        font-family: 'Inter', sans-serif;
                        font-size: 16px;
                        font-weight: 600;
                        display: inline;
                        color: #272c49;
                    "
                    >€</span
                    >
                    <span
                    style="
                        font-family: 'Inter', sans-serif;
                        font-size: 12px;
                        font-weight: 400;
                        display: inline;
                        color: #80b726;
                    "
                    >/mois</span
                    >
                </span>
                </div>
                <span
                style="
                    font-size: 12px;
                    color: #616970;
                    font-family: 'Nunito', sans-serif;
                "
                >
                ${(cost * 12).toFixed()} €/an
                <small
                    style="
                    font-size: 12px;
                    font-weight: 400;
                    color: #616970;
                    font-family: 'Nunito', sans-serif;
                    "
                    >tous frais inclus</small
                >
                </span>
            </div>
            <div>${get(upsells, get(insurancePlan, "id"), [])
              .map(
                (upSell) =>
                  `<div>${get(upSell, "insurancePlan.name")} - ${get(upSell, "cost")} €/mois</div>`,
              )
              .join("")}</div>
            </td>
            ${
              addLinks
                ? `<td style="width: 40%; font-family: 'Nunito', sans-serif; vertical-align: middle; text-align: right;">
                <a href="#" style="color: #ffffff; font-family: 'Nunito', sans-serif; text-align: center; display: inline-block; padding: 16px 24px; background-color: #80b726; border: none; font-size: 16px; font-weight: 700; border-radius: 50px; text-decoration: none; box-sizing: border-box;">${buttonLabel}</a>
            </td>`
                : ""
            }
        </tr>
        </table>
    </div>
    <br/>`),
      "",
    )}
    </div>`;
};

export default buildCardBlockHtml;
